<div>
    <login-home-navigation></login-home-navigation>
	<p>&nbsp;</p>
</div>

<section class="hero-section">

    <div class="container">

        <div class="hero-content">

            <span class="hero-badge">
                India's Manufacturing Supplier Network
            </span>

            <h1>
                Find Verified Manufacturing<br>
                Suppliers Across India
            </h1>

            <p>
                Connect with qualified machining, casting, forging,
                fabrication and component manufacturers without spending
                weeks searching for suppliers.
            </p>

            <div class="hero-buttons">
                <a routerLink="/buyersbenefits" class="btn-primary">
                    Find Suppliers
                </a>

                <a routerLink="/login/signup" class="btn-secondary">
                    Submit RFQ
                </a>
            </div>

            <!-- <div class="hero-stats">

                <div>
                    <h3>16,000+</h3>
                    <p>Suppliers</p>
                </div>

                <div>
                    <h3>300+</h3>
                    <p>Buyers</p>
                </div>

                <div>
                    <h3>3,000+</h3>
                    <p>Business Matches</p>
                </div>

            </div> -->

        </div>

    </div>

</section>
  <section class="trust-section">

    <div class="container">

        <div class="trust-grid">

            <div class="trust-item">
                <h3>16,000+</h3>
                <span>Verified Suppliers</span>
            </div>

            <div class="trust-item">
                <h3>300+</h3>
                <span>Active Buyers</span>
            </div>

            <div class="trust-item">
                <h3>3,000+</h3>
                <span>Business Matches</span>
            </div>

            <div class="trust-item">
                <h3>40+</h3>
                <span>Manufacturing Categories</span>
            </div>

        </div>

    </div>

</section>

<section class="category-section">

    <div class="container">

        <div class="section-header">
            <h2>Manufacturing Categories We Support</h2>

            <p>
                Access verified suppliers across India's leading
                manufacturing industries.
            </p>
        </div>

        <div class="row">

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <img src="assets/images/media/home/machin_new.webp" alt="Machining">
                    <h4>CNC Machining</h4>
                    <p>Turning, Milling, Grinding & Precision Components</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <img src="assets/images/media/home/castbtn.webp" alt="Casting">
                    <h4>Casting</h4>
                    <p>Sand Casting, Investment Casting & Die Casting</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <img src="assets/images/media/home/forgbtn.webp" alt="Forging">
                    <h4>Forging</h4>
                    <p>Open Die, Closed Die & Precision Forgings</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <img src="assets/images/media/home/fabbtn.webp" alt="Fabrication">
                    <h4>Fabrication</h4>
                    <p>Sheet Metal, Welding & Structural Fabrication</p>
                </div>
            </div>

        </div>

        <div class="row mt-4">

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <img src="assets/images/media/home/pressbtn.webp" alt="Pressing">
                    <h4>Press Components</h4>
                    <p>Stamping & Press Tool Manufacturing</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <i class="fa fa-cubes category-icon"></i>
                    <h4>Plastic Moulding</h4>
                    <p>Injection Moulding & Engineering Plastics</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <i class="fa fa-microchip category-icon"></i>
                    <h4>Electronics</h4>
                    <p>PCB Assembly & Electronics Manufacturing</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6">
                <div class="category-card">
                    <i class="fa fa-cogs category-icon"></i>
                    <h4>Assemblies</h4>
                    <p>Mechanical & Electro-Mechanical Assemblies</p>
                </div>
            </div>

        </div>

        <div class="text-center mt-5">

            <a routerLink="/buyersbenefits" class="category-cta">
                Find Suppliers Now
            </a>

        </div>

    </div>

</section>

<section class="why-gyv">

    <div class="container">

        <h2>Why Procurement Teams Choose GYV</h2>

        <div class="row">

            <div class="col-lg-3">
                <h4>Verified Suppliers</h4>
                <p>Access qualified manufacturers across India.</p>
            </div>

            <div class="col-lg-3">
                <h4>Faster Sourcing</h4>
                <p>Reduce supplier search time significantly.</p>
            </div>

            <div class="col-lg-3">
                <h4>Multiple Quotations</h4>
                <p>Compare suppliers before making decisions.</p>
            </div>

            <div class="col-lg-3">
                <h4>Manufacturing Expertise</h4>
                <p>Supported by industry professionals.</p>
            </div>

        </div>

    </div>

</section>


<section class="how-it-works-section">

    <div class="container">

        <div class="section-header">

            <span class="section-tag">
                How It Works
            </span>

            <h2>
                Find Qualified Manufacturing Suppliers in 3 Simple Steps
            </h2>

            <p>
                Skip weeks of supplier searching. Let GYV help you identify
                verified manufacturing partners across India.
            </p>

        </div>

        <div class="row">

            <div class="col-lg-4 col-md-4 col-sm-12">

                <div class="step-card">

                    <div class="step-number">1</div>

                    <h3>Share Your Requirement</h3>

                    <p>
                        Submit your RFQ, drawing, BOM, component details
                        or sourcing requirement.
                    </p>

                </div>

            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">

                <div class="step-card">

                    <div class="step-number">2</div>

                    <h3>Supplier Identification</h3>

                    <p>
                        Our team identifies suitable manufacturers
                        based on process, capacity and capabilities.
                    </p>

                </div>

            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">

                <div class="step-card">

                    <div class="step-number">3</div>

                    <h3>Connect & Source</h3>

                    <p>
                        Receive supplier recommendations and
                        start discussions for quotations and orders.
                    </p>

                </div>

            </div>

        </div>

        <div class="success-banner">

            <div class="row align-items-center">

                <div class="col-lg-8">

                    <h3>
                        3,000+ Successful Buyer-Supplier Matches
                    </h3>

                    <p>
                        Manufacturers and procurement teams across India
                        trust GYV for supplier discovery.
                    </p>

                </div>

                <div class="col-lg-4 text-center">

                    <a routerLink="/customerwins"
                       class="success-btn">
                        View Success Stories
                    </a>

                </div>

            </div>

        </div>

    </div>

</section>




  
        
       

   
  

<section class="rfq-cta">

    <div class="container">

        <h2>Need Suppliers for Your Next Project?</h2>

        <p>
            Share your requirement and get connected with qualified
            manufacturers across India.
        </p>

        <a routerLink="/buyersbenefits" class="rfq-btn">
            Submit RFQ
        </a>

    </div>

</section>

  <section class="success-section">

    <div class="container">

        <div class="section-header">

            <span class="section-tag">
                Success Stories
            </span>

            <h2>
                Trusted by Manufacturing Companies Across India
            </h2>

            <p>
                Real business outcomes achieved through the GYV supplier network.
            </p>

        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">

                <div class="testimonial-card">

                    <div class="testimonial-header">

                        <img src="assets/images/media/home/review/kirdak.webp">

                        <div>
                            <h5>Jagannath Ramdasi</h5>
                            <span>Kirdak Autocomp Pvt Ltd</span>
                        </div>

                    </div>

                    <div class="testimonial-result">
                        ₹25 Lakhs Monthly Business Opportunity
                    </div>

                    <p>
                        GYV helped us connect with relevant manufacturing buyers and generate new business opportunities consistently.
                    </p>

                </div>

            </div>

            <div class="col-lg-4 col-md-6">

                <div class="testimonial-card">

                    <div class="testimonial-header">

                        <img src="assets/images/media/home/review/dim.webp">

                        <div>
                            <h5>Ankit Patel</h5>
                            <span>Dimension Enterprise</span>
                        </div>

                    </div>

                    <div class="testimonial-result">
                        First Order Through GYV
                    </div>

                    <p>
                        The RFQs are genuine and relevant. We secured our first order and continue receiving valuable opportunities.
                    </p>

                </div>

            </div>

            <div class="col-lg-4 col-md-6">

                <div class="testimonial-card">

                    <div class="testimonial-header">

                        <img src="assets/images/media/home/review/mns.webp">

                        <div>
                            <h5>Arvind Shete</h5>
                            <span>MNS Engineers</span>
                        </div>

                    </div>

                    <div class="testimonial-result">
                        Bulk Order Within One Month
                    </div>

                    <p>
                        Within a month of joining, we connected with buyers across India and secured new business opportunities.
                    </p>

                </div>

            </div>

        </div>

        <div class="text-center mt-5">

            <a routerLink="/customerwins" class="success-btn">
                View More Success Stories
            </a>

        </div>

    </div>

</section>
   <section class="industry-insights">

```
<div class="container">

    <div class="insights-box">

        <h3>Industry Insights</h3>

        <div class="insight-links">

            <a routerLink="/blog/4-Tips-To-Optimize-Your-Supply-Chain-Cost">
                Reduce Supply Chain Costs
            </a>

            <a routerLink="/blog/Vendor-Development-strategic-sourcing">
                Strategic Vendor Development
            </a>

            <a routerLink="/blog/Custom-Manufacturing-The-USP-of-distinctive-brands">
                Custom Manufacturing Guide
            </a>

            <a routerLink="/blog/How-to-Find-Reliable-Indian-Manufacturing-Vendors">
                Finding Reliable Suppliers
            </a>

        </div>

        <a routerLink="/blog" class="view-all-btn">
            View All Articles →
        </a>

    </div>

</div>


</section>


    <login-home-footer></login-home-footer>